<template>
  <!-- #region template -->
  <router-view />
  <!-- #endregion -->
</template>

<script>
// #region script
// #region import
// #endregion

// #region export
export default {
  name: 'App',
  metaInfo: {
    title: 'Configurator Dashboard',
  },
}
// #endregion
// #endregion
</script>
